import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { PromptTextProps } from '../Provider';
import { ThemeProvider } from '@emotion/react';
import { useAppSelector } from '../../../hooks';
import { createTheme } from '@mui/material';
import { selectTheme } from '../../../slices/global/themeSlice';

interface Props {
  promptText: PromptTextProps;
}

export default function PromptDialog({ promptText }: Props) {
  const { open, title, message, acceptText, rejectText, proceed, reject, textLabel } = promptText;
  const [value, setValue] = React.useState('');
  const mode = useAppSelector(selectTheme);
  const canProceed = value && value.length > 0;

  React.useEffect(() => {
    setValue('');
  }, [open]);

  const darkTheme = createTheme({
    palette: {
      mode: mode,
    },
  });

  const handleTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
  };

  return (
    <ThemeProvider theme={darkTheme}>
      <Dialog
        open={open}
        onClose={(_, reason: string) => {
          if (reason === 'backdropClick' || !reject) return;
          reject();
        }}
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{message}</DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label={textLabel}
            type="email"
            fullWidth
            variant="standard"
            value={value}
            onChange={handleTextChange}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                proceed && canProceed && proceed(value);
              }
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => reject && reject()}>{rejectText}</Button>
          <Button disabled={!canProceed} onClick={() => proceed && canProceed && proceed(value)}>
            {acceptText}
          </Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
}
